import { TextField } from '@mui/material';

interface IProps {
  setProfessionalName: (ProfessionalName: string | null) => void;
  ProfessionalName: string | null | undefined;
}

const SearchProfessionalName = (props: IProps) => {
  return (
    <TextField
      size="small"
      fullWidth
      label="Nome do profissional"
      placeholder="Informe nome do profissional"
      value={props.ProfessionalName}
      onChange={e => {
        props.setProfessionalName(e.target.value);
      }}
    />
  );
};

export default SearchProfessionalName;
